import React from "react";
// import { IQuestionsModel } from "../../models/DocModel";

interface IProductionQuestionsListProps {
  questionsList?: string[];
  onQuestionClick?: (question: string) => void;
}

const ProductionQuestionsList = (props: IProductionQuestionsListProps) => {
  const { questionsList, onQuestionClick } = props;
  
    
//   chatbot_prompts?.map((each: any) => {
//     const promptKey = Object.keys(each)?.find(str => str?.includes('prompt'))
//       if (promptKey) {
//         return each?.[promptKey].
//       }
//     }) 
//   const sendWithText = (each:any) =>{
//     let finalText = Object.keys(each)?.find(str => str?.includes('prompt'))
//     onQuestionClick && each && finalText && onQuestionClick(finalText);
//   }
  return questionsList && questionsList?.length > 0 ? (
    <div className="questions-list">
      {questionsList?.map((each) => (
        <div
          key={each}
          className="question-item"
          onClick={() => onQuestionClick && each && onQuestionClick(each)}
        >
          {Object.values(each) || ''}
        </div>
      ))}
    </div>
  ) : (
    <></>
    // <div className="not-found">No questions found.</div>
  );
};

export default ProductionQuestionsList;
